import {applyMiddleware, compose, createStore} from 'redux';
import rootReducer from '../reducers/rootReducer';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import {APP_IS_DONE_LOADING} from "../actions/globalAction";

export default function configureStore(initialState) {

    const fadeOutLoader = () => next => action => {
        if (action && action.type === APP_IS_DONE_LOADING) {
            //this informs north that the app is loaded
            if (window.parent) {
                window.parent.postMessage("iframeLoaded", "*");
            }
        }
        return next(action);
    };

    const middleware = [thunk, fadeOutLoader];

    if (process.env.NODE_ENV !== 'production') {
        middleware.push(reduxImmutableStateInvariant());
    }

    let composedMiddleware;
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        composedMiddleware = compose(
            applyMiddleware(...middleware),
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
        );
    } else {
        composedMiddleware = applyMiddleware(...middleware);
    }

    return createStore(
        rootReducer,
        initialState,
        composedMiddleware
    );
}
